import React from 'react'

export default () => (
    <div>
		Container
	</div>
)